import { render, staticRenderFns } from "./BasicUpload.vue?vue&type=template&id=2ceb0d55&scoped=true&"
import script from "./BasicUpload.vue?vue&type=script&lang=js&"
export * from "./BasicUpload.vue?vue&type=script&lang=js&"
import style0 from "./BasicUpload.vue?vue&type=style&index=0&id=2ceb0d55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb0d55",
  null
  
)

export default component.exports